import { ArrowRight } from "lucide-react";

export default function HeroSlidePreview({ s }) {
  return (
    <div className="rounded-lg overflow-hidden border border-white/10 relative h-48" data-testid="slide-preview">
      {s.image && <div className="absolute inset-0" style={{ backgroundImage: `url(${s.image})`, backgroundSize: "cover", backgroundPosition: "center" }} />}
      <div className="absolute inset-0" style={{ background: "linear-gradient(to right, rgba(15,23,42,0.92), rgba(15,23,42,0.70))" }} />
      <div className="relative p-5 max-w-md">
        {s.subtitle && <div className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/10 px-2 py-0.5 text-[9px] font-mono text-blue-200 mb-2"><span className="h-1.5 w-1.5 rounded-full bg-emerald-400" /> {s.subtitle}</div>}
        <div className="font-display text-xl font-black leading-tight text-white" data-testid="slide-preview-title">{s.title || "Slide title"}</div>
        {s.description && <p className="text-[11px] text-slate-200 mt-2 line-clamp-2">{s.description}</p>}
        <div className="flex gap-2 mt-3">
          {s.b1_text && <span className="h-7 px-3 rounded-md bg-blue-600 text-white text-[10px] font-semibold flex items-center gap-1">{s.b1_text} <ArrowRight className="h-3 w-3" /></span>}
          {s.b2_text && <span className="h-7 px-3 rounded-md bg-white/10 border border-white/20 text-white text-[10px] flex items-center">{s.b2_text}</span>}
        </div>
      </div>
      <span className="absolute top-2 right-2 text-[9px] font-mono uppercase text-slate-300 bg-black/40 px-1.5 py-0.5 rounded">Live preview</span>
    </div>
  );
}
